import CloseIcon from '@mui/icons-material/Close';
import React, { useState } from 'react';
import { Accordion, Table } from 'react-bootstrap';
import initialFaqData from '../../assets/F&Q/UpdatedFAQList.json';
import "../Dynamic/BarrelSelectionPanel.scss";
import { statusData } from '../Common/StatusFaqModal';

interface SupportFaqPanelProps {
    handleCloseFaq: () => void;
}
interface FAQItem {
    id: any;
    question: string;
    answer: any;
  }

interface FAQSection {
    section: string;
    items: FAQItem[];
  }
// function BarrelSelectionPanel({ handleCloseFaq })
const BarrelSelectionPanel: React.FC<SupportFaqPanelProps> = ({ handleCloseFaq }) => {
    const statusSection: FAQSection = {
        section: "Status Descriptions",
        items: [
            {
                id: "status-reference",
                question: "Status Reference",
                answer: (
                    <div className="table-responsive service-detail-table-wrapper">
                        <Table className="service-detail-table mb-0">
                            <thead>
                                <tr>
                                    <th style={{ width: "30%" }}>Status</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {statusData.map((row, idx) => (
                                    <tr key={idx}>
                                        <td style={{ fontWeight: 600 }}>{row.status}</td>
                                        <td>{row.desc}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                )
            }
        ]
    };

    const [faqData, setFaqData] = useState<FAQSection[]>([
        ...initialFaqData.FAQList,
        statusSection
    ]);

    return (
        <>
            <div className="faq-offcanvas-wrapper">
                <div className='faq-panel-left' onClick={handleCloseFaq}></div>
                <div className='faq-panel-inner' >
                    <div className='header'>
                        <div className='header-inner d-flex justify-content-between align-items-start'>
                            <div>
                                <p className='main-heading mb-0'>FAQ</p>
                                <p className='contact-us-text mt-2 mb-0'>Contact us at <a href="mailto:support@whitedogtradingpost.com" >support@whitedogtradingpost.com</a>, if you have any questions.</p>
                            </div>
                            <div>
                                
                            <button onClick={handleCloseFaq} className='close-btn'><CloseIcon /></button>
                            </div>
                        </div>
                    </div>
                    <div className='faq-panel-body'>
                    {/* <FAQList/> */}
                        <div>
                            <div className='upload_csv--user__faq'>
                                <Accordion>
                                    {faqData.map((section) => (
                                        <div key={section.section}>
                                            {/* <Typography variant="h5" sx={{ marginTop: '20px' }}>{section.section}</Typography> */}
                                            <p className='section-heading'>{section.section}</p>
                                            {section.items.map((item) => (
                                                <Accordion.Item eventKey={item.id.toString()} key={item.id}>
                                                    <Accordion.Header>{item.question}</Accordion.Header>
                                                    <Accordion.Body>
                                                        {item.answer}
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            ))}
                                        </div>
                                    ))}
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BarrelSelectionPanel
